export default __webpack_public_path__ + "static/media/transbrasil-icon.404d4e49.png";